<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div :class="['pad-layout', { 'dark-mode': $route.meta.darkMode }]">
    <!-- <div class="linear-bg"></div> -->
    <div class="pad-layout-content">
      <div class="header">
        <div class="head-info">
          <div class="enterprise-name">
            {{ userInfo?.result?.enterpriseName }}
          </div>
          <div class="user-info">
                      <div v-if="expirationType" class="expiration-time">{{ expirationTime }}</div>

            <div class="resource-updates" v-show="isShowResourceUpdates" @click="handleUpdate">
              <div></div>
              <div class="">有新版本</div>
            </div>
            <img class="user-avatar" :src="userInfo.avatar || headSculpture" alt="" />
            <div class="user-name">{{ userInfo.nickname }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="box"> -->
        <div class="sidebar-box">
          <div class="sidebar">
            <div class="sidebar-router">
              <div :class="['sidebar-item', { active: item.checked }]" v-for="item in sidebarList" :key="item.path">
                <div :class="['sidebar-item-title']" @click="handleClick(item)">
                  <span class="icon"><img :src="item.checked ? ($route.meta.darkMode ? item.darkCheckedIcon : item.checkedIcon) : ($route.meta.darkMode ? item.darkIcon : item.icon)" alt="" />
                  </span>
                  <span :class="[ { activename: item.checked,noactivename: !item.checked }]">{{ item.name }}</span>
                </div>
              </div>
            </div>
            <div class="operator">
              <div class="operator-item" v-for="item in operatorList" :key="item" @click="handleOper(item)">
                <i :class="['iconfont', item.icon]"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="content">
          <slot name="routerView"> </slot>
        </div>
      <!-- </div> -->
    </div>
  </div>
</template>
<script setup>
  import { getUserInfo } from '@/api/login/login'

import { reactive, watch, onMounted, ref,computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import headSculpture from '@/assets/images/me/default-avatar.png'
import { isSupport, xda } from "@hybird/flutter";
import { Device } from '@hybird/device'
const route = useRoute()
const router = useRouter()
const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')

import home from '@/assets/images/home/pad-sidebar/home.png'
import seal from '@/assets/images/home/pad-sidebar/seal.png'
import myDevice from '@/assets/images/home/pad-sidebar/my-device.png'
import myLaunch from '@/assets/images/home/pad-sidebar/my-launch.png'
import homeActive from '@/assets/images/home/pad-sidebar/home-active.png'
import sealActive from '@/assets/images/home/pad-sidebar/seal-active.png'
import myDeviceActive from '@/assets/images/home/pad-sidebar/my-device-active.png'
import myLaunchActive from '@/assets/images/home/pad-sidebar/my-launch-active.png'

import myLaunchActiveDark from '@/assets/images/home/pad-sidebar/my-launch-active-dark.png'
import myDeviceActiveDark from '@/assets/images/home/pad-sidebar/my-device-active-dark.png'
import sealActiveDark from '@/assets/images/home/pad-sidebar/seal-active-dark.png'
import homeActiveDark from '@/assets/images/home/pad-sidebar/home-active-dark.png'
import myLaunchDark from '@/assets/images/home/pad-sidebar/my-launch-dark.png'
import myDeviceDark from '@/assets/images/home/pad-sidebar/my-device-dark.png'
import sealDark from '@/assets/images/home/pad-sidebar/seal-dark.png'
import homeDark from '@/assets/images/home/pad-sidebar/home-dark.png'

import { GLOBAL_ENUM } from '@/utils/yky/index'
import { logoutApi } from '@/api/me/me.js'
import { userLogout,getDeviceInfo } from '@/utils/env'
import { Dialog } from 'vant'
import { useDeviceStore } from '@/store/home'
import { useUserStore } from '@/store/home'

const deviceStore = useDeviceStore()

const isShowResourceUpdates = ref(false)

const sidebarList = reactive([
  {
    name: '首页',
    path: '/home',
    icon: home,
    checkedIcon: homeActive,
    darkIcon: homeDark,
    darkCheckedIcon: homeActiveDark,
    checked: false,
    type: GLOBAL_ENUM.CLICK_EVENT_TYPE.ROUTE_JUMP
  },
  {
    name: '用印',
    path: '/padUseSeal',
    icon: seal,
    checkedIcon: sealActive,
    darkIcon: sealDark,
    darkCheckedIcon: sealActiveDark,
    checked: false,
    type: GLOBAL_ENUM.CLICK_EVENT_TYPE.ROUTE_JUMP,
    query: {
      pageSource: 1
    }
  },
  // {
  //   name: '我发起的',
  //   path: '/myLaunch',
  //   icon: myLaunch,
  //   checkedIcon: myLaunchActive,
  //   darkIcon: myLaunchDark,
  //   darkCheckedIcon: myLaunchActiveDark,
  //   checked: false,
  //   type: GLOBAL_ENUM.CLICK_EVENT_TYPE.ROUTE_JUMP
  // },
  {
    name: '设备',
    path: '/deviceYKY',
    icon: myDevice,
    checkedIcon: myDeviceActive,
    darkIcon: myDeviceDark,
    darkCheckedIcon: myDeviceActiveDark,
    checked: false,
    type: GLOBAL_ENUM.CLICK_EVENT_TYPE.ROUTE_JUMP
  },
  {
    name: '我的',
    path: '/me',
    icon: myLaunch,
    checkedIcon: myLaunchActive,
    darkIcon: myLaunchDark,
    darkCheckedIcon: myLaunchActiveDark,
    checked: false,
    type: GLOBAL_ENUM.CLICK_EVENT_TYPE.ROUTE_JUMP
  }
])

const operatorList = reactive([
  // {
  //   name: '设置',
  //   key: 'setting',
  //   icon: 'icon-shezhi',
  //   checked: false,
  //   path: '/ykySetting',
  //   type: GLOBAL_ENUM.CLICK_EVENT_TYPE.ROUTE_JUMP
  // },
  {
    name: '退出登录',
    key: 'logout',
    icon: 'icon-daochuPDF',
    type: GLOBAL_ENUM.CLICK_EVENT_TYPE.SELF_HANDLE,
    eventHandle: () => {
      logout()
    }
  }
])

const appdata = async () => {
      const { data } = await getUserInfo()
      localStorage.setItem('currentStaffID', data.result.staffId)
      localStorage.setItem('enterpriseId', data.result.enterpriseId)
      localStorage.setItem('userInfo', JSON.stringify(data))
      const userStore = useUserStore()
      userStore.userInfo = data.result
      meData.value = data
      meData.value.expirationType = meData.value?.result?.expirationType
      meData.value.expirationTime = meData.value?.result?.expirationTime
    }

const meData = ref(userInfo)
meData.value.expirationType = meData.value?.result?.expirationType
meData.value.expirationTime = meData.value?.result?.expirationTime



const expirationTime = computed(() => {
      const expirationTime = meData.value?.result?.expirationTime || ''
      if (!expirationTime) {
        return ''
      }
      const expirationTimeSpace = Math.max(0, Math.ceil((new Date(expirationTime+' 00:00:00').getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24))
      return '平台授权使用到期时间：' + expirationTime + ' (剩余' + expirationTimeSpace + '天)'
    })
    const expirationType = computed(() => meData.value?.expirationTime || '')

watch(
  () => route.path,
  (newPath) => {
    console.log(newPath, '监听一下')
    sidebarList.forEach((item) => {
      item.checked = item.path === newPath
    })
  },
  { immediate: true }
)


//设备处于连接就断开
const deviceLogout =  () => {
  const deviceProtocol = Device.getByNumber(
    deviceStore.connectDeviceNumber
  )?.deviceProtocol
  //处于连接时断开设备
  if (deviceProtocol?.connected) {
    deviceStore.deviceLogout()
  }
}

const handleClick = (item) => {
  if (item.type == GLOBAL_ENUM.CLICK_EVENT_TYPE.ROUTE_JUMP) {
    if (item.path === route.path) return
    deviceLogout()
    router.replace({
      path: item.path,
      query: item.query || {}
    })
  }
}

const handleOper = (item) => {
  if (item.type == GLOBAL_ENUM.CLICK_EVENT_TYPE.ROUTE_JUMP) {
    if (item.path) {
      //断开设备
      deviceLogout()
      router.push({
        path: item.path
      })
    }
  }

  if (item.type == GLOBAL_ENUM.CLICK_EVENT_TYPE.SELF_HANDLE) {
    item.eventHandle && item.eventHandle()
  }
}

const logout = () => {
  Dialog.confirm({
    title: '提示',
    message: '是否确认退出登录？'
  })
    .then(async () => {
      try {
        deviceLogout()  
        await logoutApi({ json: 1 })
        await userLogout()
      } catch (error) {
        console.log('退出登录',error)
      } finally {
        router.replace({ path: '/loginAccount' })
      }
    })
    .catch(() => {
      // on cancel
    })
}

const handleUpdate = () => {
  deviceLogout()
  if (xda?.updateVersion) {
    const deviceInfo =  getDeviceInfo();
    xda.updateVersion(2, {
      number: deviceInfo?.device?.number,
      onProgress: (progress) => {
        console.log("updateVersion", JSON.stringify(progress));
      },
    });
  }
}

const checkVersion = async () =>{
  if (xda?.checkVersion) {
    const deviceInfo = getDeviceInfo()
    isShowResourceUpdates.value = await xda.checkVersion(2, deviceInfo?.device?.number);
  }
}

onMounted(()=>{
  checkVersion()
  appdata()
})
</script>
<style lang="less" scoped>
@import url(./index.less);
</style>
